import React, { useState, useEffect } from "react";
import { Badge, Box, Button, Text, createStyles } from "@mantine/core";
import "./animation.css"; // Import the CSS file
import { IconSparkles } from "@tabler/icons-react";

const useStyles = createStyles(() => ({
  default: {
    borderRadius: "8px",
    marginLeft: "40px",
    marginRight: "40px",
    height: "100%",
    padding: "16px",
    marginTop: "16px",
  },
  text: {
    fontWeight: 600,
    fontSize: "18px",
    lineHeight: "30px",
    color: "#262930",
  },
  listBox: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  lisBox1: {
    display: "flex",
    flexDirection: "row",
    gap: "24px",
  },
  listHeading: {
    color: "#586171",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "22px",
    display: "flex",
    alignItems: "center",
  },
  textBox: {
    height: "100%",
    backgroundColor: "#F5F5F5",
    borderRadius: "4px",
    padding: "4px 8px 4px 8px",
  },
  listText: {
    color: "#586171",
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "20px",
  },

  highlightBadge: {
    padding: "2px 6px",
    borderRadius: "4px",
    display: "inline-block",
    margin: "2px 2px",
    position: "relative",
    zIndex: 1,
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "currentColor",
      opacity: 0.1,
      borderRadius: "inherit",
      zIndex: -1,
    },
  },
}));

interface TypingTextProps {
  text: string;
  old?: boolean;
  Cardiovascular?: string;
}

const TypingText: React.FC<TypingTextProps> = ({ text, old }) => {
  const [displayedText, setDisplayedText] = useState("");
  

  useEffect(() => {
    if (old) {
      setDisplayedText(text);
      return;
    }
    let index = -1;
    setDisplayedText("");
    const intervalId = setInterval(() => {
      if (index == text.length - 1) {
        clearInterval(intervalId);
        return;
      }
      index++;
      setDisplayedText((prev) => prev + text[index]);
    }, 19);
    return () => clearInterval(intervalId);
  }, [text]);

  return <div dangerouslySetInnerHTML={{ __html: displayedText }} />;
};
export function parseFlaggedString(str: any) {
  const regex = /\[(#[0-9A-Fa-f]{6}) (\w+)\]/g;
  return str.replace(regex, (match: any, color: any, word: any) => {
    return <Badge color={color}>${word}</Badge>;
  });
}
export const StringParser = (originalString: any) => {
  const parsedString = parseFlaggedString(originalString);

  return <div dangerouslySetInnerHTML={{ __html: parsedString }} />;
};

interface SummaryProps {
  text: string;
  old?: boolean;
  cardiovascular?: string;
  diseases?: string[];
  drugs?: string[];
  observations?: string[];
  cardioRed?: boolean;
  title?: string;
  Embed?: boolean;
  regenerate?: any;
  aiButtonName?: any;
}

export const Summary: React.FC<SummaryProps> = ({
  text,
  cardiovascular,
  diseases,
  drugs,
  observations,
  cardioRed = false,
  title,
  old,
  Embed,
  regenerate,
  aiButtonName
}) => {
  function addBadgeClass(input: string) {
    return input.replace(
      /<span style="/g,
      `<span class="${classes.highlightBadge}" style="`
    );
  }
  const { classes } = useStyles();

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Box>
          {Embed ? (
            <></>
          ) : (
            <Text className={classes.text} mt={16}>
              {title ?? "AI Summary"}
            </Text>
          )}
        </Box>
        <Box sx={{ display: "flex", flexDirection: "row", gap: "8px" }}>
          {Embed && (
            <Button onClick={regenerate}>
              <IconSparkles style={{marginRight:"6px"}} />
              Re-generate {aiButtonName ?? ""}
            </Button>
          )}
          {cardiovascular && (
            <Text
              color={cardioRed ? "#F12222" : "#26cc10"}
              bg={cardioRed ? "#FFF0F0" : "#f2fff0"}
              h={32}
              p={"8px 16px 8px 16px"}
              sx={{
                borderRadius: "4px",
                display: "flex",
                alignItems: "center",
              }}
            >
              {cardiovascular}
            </Text>
          )}
        </Box>
      </Box>
      <Box pt={12} className="text-container">
        <TypingText text={addBadgeClass(text)} old={old} />
      </Box>
      {((diseases?.length ?? 0) > 0 ||
        (drugs?.length ?? 0) > 0 ||
        (observations?.length ?? 0) > 0) && (
        <Box pt={12} sx={{ width: "100%" }}>
          <Text className={classes.text}>Details</Text>
          <Box
            mt={20}
            sx={{ display: "flex", flexDirection: "column", gap: "16px" }}
          >
            {diseases && (
              <Box className={classes.lisBox1}>
                <Text className={classes.listHeading}>Conditions</Text>
                {diseases.slice(0, 4).map((disease) => (
                  <Box className={classes.textBox}>
                    <Text>
                      {disease.length > 20
                        ? disease.substring(0, 20) + "..."
                        : disease}
                    </Text>
                  </Box>
                ))}
              </Box>
            )}
            {drugs && (
              <Box className={classes.lisBox1}>
                <Text className={classes.listHeading}>Medications</Text>
                {drugs.slice(0, 4).map((drug) => (
                  <Box className={classes.textBox}>
                    <Text>
                      {drug.length > 20 ? drug.substring(0, 20) + "..." : drug}
                    </Text>
                  </Box>
                ))}
              </Box>
            )}
            {observations && (
              <Box className={classes.lisBox1}>
                <Text className={classes.listHeading}>Observations</Text>
                {observations.slice(0, 4).map((obs) => (
                  <Box className={classes.textBox}>
                    <Text>
                      {obs.length > 20 ? obs.substring(0, 20) + "..." : obs}
                    </Text>
                  </Box>
                ))}
              </Box>
            )}
          </Box>
        </Box>
      )}
    </>
  );
};
